module.exports = __webpack_public_path__ + "static/media/buld.a1051a22.jpg";